import { PaginationQueries } from 'types/search.type';

export const defaultPagination: PaginationQueries = {
  page: 0,
  size: 20,
};
